import { render, staticRenderFns } from "./PunjabMap.vue?vue&type=template&id=4190daf9&scoped=true&"
import script from "./PunjabMap.vue?vue&type=script&lang=js&"
export * from "./PunjabMap.vue?vue&type=script&lang=js&"
import style0 from "./PunjabMap.vue?vue&type=style&index=0&id=4190daf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4190daf9",
  null
  
)

export default component.exports